import cookies from './util.cookies'

export const getKey = () => {
  return `admin-lang`
}

export const getLang = () => {
  return cookies.get(getKey())
}

export const setLang = lang => {
  cookies.set(getKey(), lang, { expires: 9999 })
}

export const removeLang = () => {
  cookies.remove(getKey())
}

export default {
  getKey,
  getLang,
  setLang,
  removeLang
}